import dayjs from "dayjs";
import { Paper, Typography } from "@mui/material";
import { EventStatusPill } from "../event/EventStatusPill";
import { useEventRowStyles } from "./useEventRowStyles";
import { ChevronRight } from "@mui/icons-material";
import { useIsMobile } from "../../../hooks/useIsMobile";
import { Link, useLocation } from "react-router-dom";

const eventDate = ({ date, window }) => {
    const startDate = dayjs(date);
    const endDate = dayjs(date).add(window - 1, "day");

    let days = startDate.format("D");
    let months = startDate.format("MMM");
    if( startDate.unix() !== endDate.unix())
        days += ` - ${endDate.format("D")}`;
    if (startDate.month() !== endDate.month())
        months += ` ${endDate.format("MMM")}`;
    return [months.toUpperCase(), days];
};

export const EventRowDetails = ({ event }) => {
    const classes = useEventRowStyles();
    const date = eventDate({ date: event.date, window: event.daysWindow });
    const isMobile = useIsMobile();

    return(
        <>
            <Paper variant="rounded" className={classes.box}>
                <Typography variant="label2">
                    {date[0]}
                </Typography>
                <Typography  variant="h7">
                    {date[1]}
                </Typography>
            </Paper>
            <div className={classes.details}>
                <div className={classes.title}>
                    <Typography variant="button" className={classes.name}>{event.name}</Typography>
                    <div>
                        <EventStatusPill className={classes.pill} status={event.status}/>
                    </div>
                </div>
                {event?.series?.length > 0 && <Typography variant="body1">{event.series.map(s => s.name).join(", ")}</Typography>}
            </div>
            {!isMobile && <ChevronRight className={classes.chevron}/>}
        </>
    );
};

export const EventRow = ({ event }) => {
    const classes = useEventRowStyles();

    return (
        <Link to={`/events/${event.id}`} className={classes.event}>
            <EventRowDetails event={event} />
        </Link>
    );
};

export const UserEventRow = ({ event }) => {
    const classes = useEventRowStyles();
    const location = useLocation();

    return (
        <Link to={{ pathname: `/user/events/${event.id}/athletes`, state: { from: location.pathname } }} className={classes.event}>
            <EventRowDetails event={event} />
        </Link>
    );

};
